import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { DialogData } from 'src/app/app.model';

@Component({
  selector: 'status-dialog',
  templateUrl: './statusdialog.component.html',
  styleUrls: ['./statusdialog.component.scss'],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatIconModule
  ]
})
export class StatusDialog {
  readonly dialogRef = inject(MatDialogRef<StatusDialog>);
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);

  close(): void {
    this.dialogRef.close();
  }
}
